export type IconHandleType =
    'business'
    | 'community'
    | 'cultural'
    | 'nightlife'
    | 'sports-entertainment'
    | 'sports-outdoor'


function CategoryIcon(props: { handle?: IconHandleType, className?: string, onClick?: () => void }) {

    const otherProps = {
        ...props
    }

    delete otherProps.handle


    if (props.handle === 'business') {
        return (
            <svg {...otherProps} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M20 7H4C2.89543 7 2 7.89543 2 9V19C2 20.1046 2.89543 21 4 21H20C21.1046 21 22 20.1046 22 19V9C22 7.89543 21.1046 7 20 7Z"
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path
                    d="M16 21V5C16 4.46957 15.7893 3.96086 15.4142 3.58579C15.0391 3.21071 14.5304 3 14 3H10C9.46957 3 8.96086 3.21071 8.58579 3.58579C8.21071 3.96086 8 4.46957 8 5V21"
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>

        )
    }

    if (props.handle === 'community') {
        return (
            <svg {...otherProps} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21"
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path
                    d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z"
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path
                    d="M23 20.9999V18.9999C22.9993 18.1136 22.7044 17.2527 22.1614 16.5522C21.6184 15.8517 20.8581 15.3515 20 15.1299"
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path
                    d="M16 3.12988C16.8604 3.35018 17.623 3.85058 18.1676 4.55219C18.7122 5.2538 19.0078 6.11671 19.0078 7.00488C19.0078 7.89305 18.7122 8.75596 18.1676 9.45757C17.623 10.1592 16.8604 10.6596 16 10.8799"
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>


        )
    }


    if (props.handle === 'cultural') {
        return (
            <svg {...otherProps} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.1828 8.56C13.1828 8.56 14.2737 8 17.001 8C19.7282 8 23.001 8.56 23.001 8.56V15.84C23.001 19.2421 20.3147 22 17.001 22C13.9496 22 11.4303 19.6615 11.0505 16.6349C11.0178 16.3747 11.001 16.1094 11.001 15.84V14.5"
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <circle cx="19.001" cy="13" r="1" fill="currentColor"/>
                <circle cx="15.001" cy="13" r="1" fill="currentColor"/>
                <path d="M20.001 17C18.3441 15.6667 15.6578 15.6667 14.001 17" stroke="currentColor" strokeWidth="2"
                      strokeLinecap="round" strokeLinejoin="round"/>
                <path
                    d="M1 2.56C1 2.56 4.1114 2 6.45455 2C8.79769 2 13 2.56 13 2.56V10C13 13.3137 10.3137 16 7 16C3.68629 16 1 13.3137 1 10V2.56Z"
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M10 10C8.34315 11.3333 5.65685 11.3333 4 10" stroke="currentColor" strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"/>
                <circle cx="5" cy="7" r="1" fill="currentColor"/>
                <circle cx="9" cy="7" r="1" fill="currentColor"/>
            </svg>


        )
    }

    if (props.handle === 'nightlife') {
        return (
            <svg {...otherProps} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 14.5L20 7V4H4V7L12 14.5ZM12 14.5V22M12 22H6.33333M12 22H17.6667" stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M20 7C21.6569 7 23 5.65685 23 4C23 2.34315 21.6569 1 20 1C18.3431 1 17 2.34315 17 4"
                      stroke="currentColor"
                      strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M5 7H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                      strokeLinejoin="round"/>
            </svg>


        )
    }

    if (props.handle === 'sports-entertainment') {
        return (
            <svg {...otherProps} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.94929 11.5L7.94929 7.85689C7.94703 7.65512 7.94755 5.10064 7.94829 3.16819C7.94875 1.97 8.92025 1 10.1184 1V1C11.3171 1 12.2888 1.9717 12.2888 3.17036L12.2888 6.11111L17.5542 7.32525C17.9596 7.38727 18.3291 7.59499 18.5946 7.91014C18.8602 8.22528 19.0039 8.62663 18.9992 9.04021L18.9992 18.7126M7.94929 11.5C2.49862 10.5 3.99845 18.5 9.64928 18.7126M7.94929 11.5L7.94929 13.5M9.64928 18.7126L18.9992 18.7126M9.64928 18.7126L9.64928 21.285C9.64928 21.7399 9.82839 22.1761 10.1472 22.4977C10.466 22.8193 10.8984 23 11.3493 23L17.2992 23C17.7501 23 18.1825 22.8193 18.5013 22.4977C18.8201 22.1761 18.9992 21.7399 18.9992 21.285L18.9992 18.7126"
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path
                    d="M13.862 14.085H14.519C14.888 14.085 15.194 14.391 15.194 14.76C15.194 15.129 14.888 15.435 14.519 15.435H11.675C11.306 15.435 11 15.129 11 14.76C11 14.391 11.306 14.085 11.675 14.085H12.332V10.53L11.819 10.629C11.765 10.638 11.711 10.647 11.666 10.647C11.252 10.647 11.018 10.305 11.018 9.963C11.018 9.675 11.189 9.396 11.567 9.315L13.034 9.018C13.106 9 13.178 9 13.241 9C13.619 9 13.862 9.243 13.862 9.702V14.085Z"
                    fill="currentColor"/>
            </svg>


        )
    }

    if (props.handle === 'sports-outdoor') {
        return (
            <svg {...otherProps} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12.6879" cy="3.37932" r="2.37932" stroke="currentColor" strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"/>
                <path
                    d="M7 14.1429L9.12254 7.47867C9.2107 7.20187 9.48495 7.0284 9.77283 7.06733L13.5 7.57143L16.775 9.57143L18.4168 8.77143C19.2554 8.36283 20.2619 8.78581 20.5569 9.67075C20.8082 10.4247 20.4459 11.2463 19.7196 11.5691L17.0536 12.7539C16.7056 12.9086 16.3047 12.8884 15.974 12.6994L13 11L12 14L14.403 16.403C14.7853 16.7853 15 17.3037 15 17.8443V21.275C15 22.2277 14.2277 23 13.275 23C12.3223 23 11.55 22.2277 11.55 21.275V18.1429L7 14.1429Z"
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path
                    d="M7.59292 6.37231L9 7.14286L6.83023 14L4.71708 13.1078C2.86499 12.3259 2.2911 9.97921 3.57327 8.43075L4.84173 6.89884C5.51415 6.08676 6.66817 5.8659 7.59292 6.37231Z"
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path
                    d="M7.00098 14L5.90033 17.6867L3.61818 20.2468C3.01105 20.9278 3.09957 21.9788 3.81205 22.5487V22.5487C4.47717 23.0808 5.44324 22.9949 6.00407 22.3539L8.50098 19.5L9.50098 16.5"
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M19 6L19 8M19 12L19 23" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                      strokeLinejoin="round"/>
            </svg>


        )
    }

    return (
        <span>Icon {props.handle} don&apos;t exist</span>
    );
}

export default CategoryIcon

